import {
  Autocomplete,
  Button,
  FormControl,
  MenuItem,
  Paper,
  Select,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const FiltrosPedidos = ({
  filtros,
  onFieldChange,
  onModoChange,
  onLimpiar,
  proveedores = [],
  sucursales = [],
  usuarios = [],
}) => {
  const usuarioSeleccionado =
    usuarios.find((u) => u.username === filtros.username) || null;
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 3,
        border: "1px solid rgba(0,0,0,0.08)",
        display: "flex",
        flexWrap: "wrap",
        gap: 1.5,
        alignItems: "center",
      }}
    >
      <ToggleButtonGroup
        size="small"
        exclusive
        value={filtros.modo}
        onChange={(e, val) => val && onModoChange(val)}
      >
        <ToggleButton value="rango" sx={{ textTransform: "none" }}>
          Rango
        </ToggleButton>
        <ToggleButton value="fecha" sx={{ textTransform: "none" }}>
          Día puntual
        </ToggleButton>
      </ToggleButtonGroup>

      {filtros.modo === "fecha" ? (
        <TextField
          size="small"
          type="date"
          label="Fecha"
          InputLabelProps={{ shrink: true }}
          value={filtros.fecha}
          onChange={(e) => onFieldChange("fecha", e.target.value)}
        />
      ) : (
        <>
          <TextField
            size="small"
            type="date"
            label="Desde"
            InputLabelProps={{ shrink: true }}
            value={filtros.desde}
            onChange={(e) => onFieldChange("desde", e.target.value)}
          />
          <TextField
            size="small"
            type="date"
            label="Hasta"
            InputLabelProps={{ shrink: true }}
            value={filtros.hasta}
            onChange={(e) => onFieldChange("hasta", e.target.value)}
          />
        </>
      )}

      <Autocomplete
        size="small"
        sx={{ minWidth: 240 }}
        options={usuarios}
        value={usuarioSeleccionado}
        onChange={(e, newValue) => onFieldChange("username", newValue?.username || "")}
        getOptionLabel={(u) => u.nombre_completo || u.username || ""}
        isOptionEqualToValue={(opt, val) => opt.username === val.username}
        noOptionsText="Sin resultados"
        renderInput={(params) => (
          <TextField {...params} label="Usuario" placeholder="Buscar empleado..." />
        )}
      />

      <FormControl size="small" sx={{ minWidth: 170 }}>
        <Select
          displayEmpty
          value={filtros.id_proveedor}
          onChange={(e) => onFieldChange("id_proveedor", e.target.value)}
        >
          <MenuItem value="">
            <em>Todos los proveedores</em>
          </MenuItem>
          {proveedores.map((p) => (
            <MenuItem key={p.id} value={p.id}>
              {p.nombre}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 170 }}>
        <Select
          displayEmpty
          value={filtros.id_sucursal}
          onChange={(e) => onFieldChange("id_sucursal", e.target.value)}
        >
          <MenuItem value="">
            <em>Todas las sucursales</em>
          </MenuItem>
          {sucursales.map((s) => (
            <MenuItem key={s.id} value={s.id}>
              {s.nombre}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Button
        size="small"
        color="error"
        startIcon={<CloseIcon />}
        onClick={onLimpiar}
        sx={{ textTransform: "none" }}
      >
        Limpiar
      </Button>
    </Paper>
  );
};

export default FiltrosPedidos;
